/* Nature's MACE: product page buy box behavior (PDP redesign, Oct 2026).
   Loaded only by sections/nm-pdp-core.liquid on the product template.
   Hooks into Turbo v11's `variant-change` event (fired on the product form by
   kit-variant-picker-bridge.js). Never throws: the buy box must keep working. */
(function () {
  'use strict';

  if (window.NMPDPLoaded) return;
  window.NMPDPLoaded = true;

  var ACRE = 43560;

  function log(error) {
    if (window.console) console.error('[NM PDP]', error);
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  function readData() {
    var node = document.getElementById('nm-pdp-data');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      log(error);
      return null;
    }
  }

  function delimit(cents, precision, thousands, decimal) {
    var parts = (cents / 100).toFixed(precision).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts[0] + (parts[1] ? decimal + parts[1] : '');
  }

  function formatMoney(cents, format) {
    var amount = Math.round(Number(cents) || 0);
    var template = format || '${{amount}}';
    var match = template.match(/\{\{\s*(\w+)\s*\}\}/);
    var value;

    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals':
        value = delimit(amount, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        value = delimit(amount, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = delimit(amount, 0, '.', ',');
        break;
      default:
        value = delimit(amount, 2, ',', '.');
    }

    return template.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  function formatNumber(value) {
    return String(Math.round(value)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  // Must match the Liquid in snippets/nm-pdp.liquid ('coverage' part).
  // Square feet below 2 acres (unless an exact acre count, e.g. 43,560), acres
  // above. Acres round down to one decimal so the page never overstates the label.
  function coverageLabel(sqft) {
    if (!sqft) return '';
    if (sqft >= 2 * ACRE || (sqft >= ACRE && sqft % ACRE === 0)) {
      var acres = Math.floor((sqft * 10) / ACRE) / 10;
      return acres + (acres === 1 ? ' acre' : ' acres');
    }
    return formatNumber(sqft) + ' sq ft';
  }

  function init() {
    var data = readData();
    var section = document.querySelector('.js-product-section--product');
    if (!data || !data.variants || !section) return;

    var details = section.querySelector('.product__details');
    var form = section.querySelector('form[action*="/cart/add"]');
    var sticky = document.getElementById('nm-sticky');
    var stickyAdd = sticky ? sticky.querySelector('[data-nm-sticky-add]') : null;
    var state = { variantId: String(data.variant) };

    function currentVariant() {
      return data.variants[state.variantId] || null;
    }

    function sellingPlanId() {
      if (!form || !window.FormData) return '';
      try {
        return new FormData(form).get('selling_plan') || '';
      } catch (error) {
        return '';
      }
    }

    function quantity() {
      var input = form ? form.querySelector('input[name="quantity"]') : null;
      var value = input ? parseInt(input.value, 10) : 1;
      return value > 0 ? value : 1;
    }

    function unitPrice(variant) {
      var plan = sellingPlanId();
      if (plan && variant.plans && variant.plans[plan] != null) return variant.plans[plan];
      return variant.price;
    }

    function realButton() {
      return form ? form.querySelector('.add_to_cart') : null;
    }

    function buttonBlocked(button) {
      return !button || button.disabled || button.classList.contains('disabled');
    }

    /* Coverage line ------------------------------------------------------ */
    // "Treats up to X · $Y per 1,000 sq ft" (or "per acre") wraps only at the dot, so it
    // never runs past two lines. A size with a volume but no coverage shows
    // "16 fl oz · $1.19 per fl oz"; a size with only a note shows the note.
    function renderCoverage(variant) {
      var box = details ? details.querySelector('[data-nm-coverage]') : null;
      if (!box) return;

      var main = box.querySelector('[data-nm-coverage-main]');
      var hasCoverage = !!(variant && variant.coverage > 0);
      var hasVolume = !hasCoverage && !!(variant && variant.floz > 0);
      var hasNote = !!(variant && variant.note);

      if (!main || (!hasCoverage && !hasVolume && !hasNote)) {
        box.hidden = true;
        return;
      }

      box.hidden = false;
      main.textContent = '';
      main.classList.toggle('nm-sep', hasCoverage || hasVolume);

      if (hasVolume) {
        var volume = el('span', 'nm-sep__in');
        volume.appendChild(el('strong', 'nm-sep__item', formatNumber(variant.floz) + ' fl oz'));
        volume.appendChild(el(
          'span',
          'nm-sep__item nm-coverage__unit',
          formatMoney(Math.round(variant.price / variant.floz), data.moneyFormat) + ' per fl oz'
        ));
        main.appendChild(volume);
        return;
      }

      if (!hasCoverage) {
        main.textContent = variant.note;
        return;
      }

      // data-nm-per="acre" (commercial template) prices per acre instead.
      var perAcre = box.getAttribute('data-nm-per') === 'acre';
      var unitArea = perAcre ? ACRE : 1000;
      var inner = el('span', 'nm-sep__in');
      inner.appendChild(el('strong', 'nm-sep__item', 'Treats up to ' + coverageLabel(variant.coverage)));
      inner.appendChild(el(
        'span',
        'nm-sep__item nm-coverage__unit',
        formatMoney(Math.round((variant.price * unitArea) / variant.coverage), data.moneyFormat) +
          (perAcre ? ' per acre' : ' per 1,000 sq ft')
      ));
      main.appendChild(inner);
    }

    /* "Choose Size: 40 oz Conc. · Makes ~5 gal of spray" ---------------- */
    // Always reads "Choose <option>" (owner request, Oct 9), whether the
    // option is named "Choose Size" or just "Size" in Shopify admin.
    function renderLegends() {
      if (!form) return;

      var variant = currentVariant();
      var note = variant && (variant.coverage > 0 || variant.floz > 0) && variant.note ? variant.note : '';
      var fieldsets = form.querySelectorAll('kit-variant-picker .kit-fieldset');

      Array.prototype.forEach.call(fieldsets, function (fieldset, index) {
        var text = fieldset.querySelector('.kit-fieldset__legend-text');
        var checked = fieldset.querySelector('input[type="radio"]:checked');
        if (!text || !checked) return;

        var name = text.getAttribute('data-nm-name');
        if (!name) {
          name = text.textContent.trim().replace(/^choose\s+(an?\s+)?/i, '');
          name = 'Choose ' + name.charAt(0).toUpperCase() + name.slice(1);
          text.setAttribute('data-nm-name', name);
        }

        var itemNote = index === 0 ? note : '';
        var key = checked.value + '|' + itemNote;
        if (text.getAttribute('data-nm-key') === key && text.querySelector('.nm-legend-value')) return;

        var wrap = el('span', 'nm-sep');
        var inner = el('span', 'nm-sep__in');
        var first = el('span', 'nm-sep__item', name + ': ');
        first.appendChild(el('span', 'nm-legend-value', checked.value));
        inner.appendChild(first);
        if (itemNote) inner.appendChild(el('span', 'nm-sep__item nm-legend-note', itemNote));
        wrap.appendChild(inner);

        text.textContent = '';
        text.appendChild(wrap);
        text.setAttribute('data-nm-key', key);
      });
    }

    /* Price inside Add to Cart ------------------------------------------ */
    function renderButtonPrice(variant) {
      var button = realButton();
      if (!button) return;

      var tag = button.querySelector('.nm-atc-price');
      if (!tag) {
        // Not a <span>: Turbo rewrites every span in this button with its label.
        tag = el('b', 'nm-atc-price');
        var label = button.querySelector('.text');
        if (label && label.parentNode === button) label.insertAdjacentElement('afterend', tag);
        else button.appendChild(tag);
      }

      var text = variant && variant.available
        ? ' · ' + formatMoney(unitPrice(variant) * quantity(), data.moneyFormat)
        : '';
      if (tag.textContent !== text) tag.textContent = text;
    }

    /* Mobile sticky bar (off until enabled in the NM buy box section) ---- */
    function renderSticky(variant) {
      if (!sticky) return;

      var meta = sticky.querySelector('[data-nm-sticky-meta]');
      var price = sticky.querySelector('[data-nm-sticky-price]');
      var parts = [];

      if (variant) {
        if (variant.title && variant.title !== 'Default Title') parts.push(variant.title);
        if (variant.coverage > 0) parts.push(coverageLabel(variant.coverage));
      }

      if (meta) {
        meta.textContent = parts.join(' · ');
        meta.hidden = !parts.length;
      }

      if (price) {
        price.textContent = variant ? formatMoney(unitPrice(variant) * quantity(), data.moneyFormat) : '';
      }

      syncStickyButton(variant);
    }

    function syncStickyButton(variant) {
      if (!stickyAdd) return;
      var v = variant || currentVariant();
      stickyAdd.disabled = buttonBlocked(realButton()) || !(v && v.available);
    }

    function setupStickyVisibility() {
      if (!sticky || !stickyAdd || !form || !('IntersectionObserver' in window)) return;

      var target = form.querySelector('.purchase-details__buttons') || realButton();
      if (!target) return;

      var media = window.matchMedia('(max-width: 989px)');
      var targetInView = true;

      function apply() {
        var show = media.matches && !targetInView;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        stickyAdd.tabIndex = show ? 0 : -1;
      }

      new IntersectionObserver(function (entries) {
        targetInView = entries[0].isIntersecting;
        apply();
      }).observe(target);

      if (media.addEventListener) media.addEventListener('change', apply);
      else if (media.addListener) media.addListener(apply);

      stickyAdd.addEventListener('click', function () {
        var button = realButton();
        if (!buttonBlocked(button)) button.click();
      });

      var button = realButton();
      if (button && 'MutationObserver' in window) {
        new MutationObserver(function () {
          syncStickyButton();
        }).observe(button, { attributes: true, attributeFilter: ['class', 'disabled'] });
      }
    }

    /* Swipe the custom gallery on touch screens --------------------------- */
    // The NM variant gallery has arrows and thumbnails but no swipe. A clear
    // horizontal swipe on the main image presses the matching arrow.
    function setupGallerySwipe() {
      var images = section.querySelector('.product__images');
      if (!images) return;

      var startX = 0;
      var startY = 0;
      var tracking = false;

      images.addEventListener('touchstart', function (event) {
        tracking = event.touches.length === 1 && !!(event.target.closest && event.target.closest('.nm-vg__stage'));
        if (!tracking) return;
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
      }, { passive: true });

      images.addEventListener('touchend', function (event) {
        if (!tracking) return;
        tracking = false;

        try {
          var touch = event.changedTouches[0];
          var dx = touch.clientX - startX;
          var dy = touch.clientY - startY;
          if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.5) return;

          var arrow = images.querySelector(dx < 0 ? '.nm-vg__arrow--next' : '.nm-vg__arrow--prev');
          if (arrow && arrow.style.display !== 'none') arrow.click();
        } catch (error) {
          log(error);
        }
      }, { passive: true });
    }

    /* Wiring ------------------------------------------------------------- */
    function refreshPrices() {
      try {
        var variant = currentVariant();
        renderButtonPrice(variant);
        renderSticky(variant);
      } catch (error) {
        log(error);
      }
    }

    function refreshAll() {
      try {
        var variant = currentVariant();
        renderCoverage(variant);
        renderLegends();
      } catch (error) {
        log(error);
      }
      refreshPrices();
    }

    document.addEventListener('variant-change', function (event) {
      try {
        if (!event.target || !event.target.closest || !event.target.closest('.js-product-section--product')) return;
        var variant = event.detail && event.detail.variant;
        state.variantId = variant && variant.id ? String(variant.id) : '';
        refreshAll();
        // Appstle re-renders its options after a size change.
        window.setTimeout(refreshPrices, 200);
      } catch (error) {
        log(error);
      }
    });

    if (form) {
      form.addEventListener('change', refreshPrices);
      form.addEventListener('input', function (event) {
        if (event.target && event.target.name === 'quantity') refreshPrices();
      });
      form.addEventListener('click', function (event) {
        if (!event.target || !event.target.closest) return;
        if (event.target.closest('.js-change-quantity, .appstle_sub_widget')) {
          window.setTimeout(refreshPrices, 0);
        }
      });

      // Appstle injects its widget after load; re-price once it arrives.
      if ('MutationObserver' in window) {
        new MutationObserver(function () {
          window.setTimeout(refreshPrices, 0);
        }).observe(form, { childList: true });
      }
    }

    refreshAll();
    setupStickyVisibility();
    setupGallerySwipe();
  }

  ready(function () {
    try {
      init();
    } catch (error) {
      log(error);
    }
  });
})();